import $ from 'cash-dom';

export default class DropDown {
  constructor(el) {
    this.el = el;
  }
  
  init() {
    this.el.on('show.bs.dropdown', (e, el) => {
      if (el) {
        $(`#${el}`).find('.dropdown-menu').first().stop(true, true)
          .slideDown();
      } else {
        $(e.target).find('.dropdown-menu').first().stop(true, true)
          .slideDown();
      }
    });

    this.el.on('hide.bs.dropdown', (e, el) => {
      if (el) {
        $(`#${el}`).find('.dropdown-menu').first().stop(true, true)
          .slideUp();
      } else {
        $(e.target).find('.dropdown-menu').first().stop(true, true)
          .slideUp();
      }
    });

    this.el.find('select.link').each((idx, el) => {
      $(el).on('change', function () {
        window.location = $(this).val();
      });
    });
  }
}
